/* Register the production service worker.
 *
 * In dev (yarn start / CRA dev server) we deliberately do NOT register the SW —
 * it cripples hot-reload. Production builds and the deployed preview register it.
 */
export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  // CRA serves the dev bundle from process.env.NODE_ENV === 'development'; skip there.
  if (process.env.NODE_ENV !== "production") return;
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch((err) => console.warn("[PWA] SW register failed", err));
  });
}
